/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {ElementRef} from '@angular/core';

/**
 * Function to check if a click occurred inside an element or its children
 * @param element The element where the click occurred
 * @param parent ElementRef of the element to check if was clicked
 * */
export function isFocusedClick(element: Element, parent: ElementRef): boolean {
    if (element === parent?.nativeElement) {
        return true;
    }
    if (!element) {
        return false;
    }
    return isFocusedClick(element?.parentElement, parent);
}
